/**
 * SourceBadge
 *
 * Badge component to display the source of an inbox message:
 * - "System" for platform messages
 * - Application name for app messages
 */

import { CogIcon, CubeIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

interface SourceBadgeProps {
  source: 'platform' | 'application';
  applicationName?: string;
  applicationCode?: string;
}

export function SourceBadge({ source, applicationName, applicationCode }: SourceBadgeProps) {
  if (source === 'platform') {
    return (
      <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-700">
        <CogIcon className="h-3 w-3" />
        System
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-700">
      <CubeIcon className="h-3 w-3" />
      {applicationName || applicationCode || 'Application'}
    </span>
  );
}

export default SourceBadge;
